module.exports = __webpack_public_path__ + "img/face_visible.325c6d7a.svg";